export { default } from './PopoverLink';



// WEBPACK FOOTER //
// src/components/layout/PopoverLink/index.js